import React from 'react'
import './colorElement.css'

const ColorElement = ({
	id, 
	color, 
	selected,
	selectedPath, 
	onClick
}) => {
	let className='color';
	if(selected)
		className+=' selected';

	const divStyle = {
		backgroundColor: color,
		width: '20px',
		height: '20px',
		cursor: 'pointer',
		paddingLeft: '2px',
		marginLeft: '5px',
		 marginBottom: '5px',
		 border: selected ? '2px solid #000' : ''
	};

	return (
		<div style={divStyle} onClick={()=> onClick(selectedPath, color, id)}></div>
	)
}

export default ColorElement;


// WEBPACK FOOTER //
// ./src/components/mosaic/colorElement.jsx